import { render, staticRenderFns } from "./OneProductGridLoader.vue?vue&type=template&id=1c6c894c&scoped=true&"
import script from "./OneProductGridLoader.vue?vue&type=script&lang=js&"
export * from "./OneProductGridLoader.vue?vue&type=script&lang=js&"
import style0 from "./OneProductGridLoader.vue?vue&type=style&index=0&id=1c6c894c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c894c",
  null
  
)

export default component.exports